// Check if a value is an object
export const isObject = value => value !== null && typeof value === 'object'

export const padZero = val => {
  return ('' + val).padStart(2, '0')
}

export function getColorTag(currentStatus, shouldApplyColor = true) {
  const errorStatuses = ['cancelled', 'danger', 'processing_failure']
  const successStatuses = ['success', 'completed', 'approved']

  if (shouldApplyColor) {
    if (errorStatuses.includes(currentStatus?.toLocaleLowerCase())) {
      return 'text-red-300 font-bold'
    } else if (successStatuses.includes(currentStatus?.toLocaleLowerCase())) {
      return 'text-green-300 font-bold'
    }
  } else {
    return ''
  }
}

export function getFormattedDate(dateString, timeCheck = false, separator = '/') {
  const date = new Date(dateString)

  const locale = navigator.language

  const dateFormat = new Intl.DateTimeFormat(locale)
  const formattedDate = dateFormat.formatToParts(date)

  const dateParts = formattedDate.filter(part => part.type === 'day' || part.type === 'month' || part.type === 'year')

  let formattedDateString = dateParts.map(part => part.value).join(separator)

  if (timeCheck) {
    const timeFormat = new Intl.DateTimeFormat(locale, {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: true,
    })

    const formattedTime = timeFormat.format(date)
    formattedDateString += ` ${formattedTime}`
  }

  return formattedDateString
}

export const getSelectedRowData = (rowSelection, records) => {
  return rowSelection?.map(selection => records?.[selection?.index]) || []
}

export const getFormattedDateString = date => {
  if (date) {
    const formattedDate = new Date(date)
    return formattedDate.toISOString()
  } else {
    return ''
  }
}

export const convertToLowerCase = content => (typeof content === 'string' ? content?.toLowerCase() : content)

export const getSegmentsDatafromSegmentsIds = (segmentsIds = [], segmentsData = []) => {
  return (
    segmentsIds?.length &&
    segmentsIds?.map(id => {
      // Convert id to string for comparison if it's not already a string
      const idToCompare = typeof id === 'string' ? id : String(id)

      // Find the segment by comparing string representations of IDs
      // Check both segmentId and id properties since the data structure might vary
      const originalSegment = segmentsData?.find(segment => String(segment?.id || segment?.segmentId) === idToCompare)

      if (!originalSegment) {
        return {
          id: idToCompare,
          name: `${idToCompare}`, // Fallback name if segment not found
        }
      }

      return {
        id: originalSegment?.id || originalSegment?.segmentId,
        name: originalSegment?.name || originalSegment?.segmentName,
        groupId: originalSegment?.groupId || originalSegment?.segmentGroupId, // Include groupId if available
      }
    })
  )
}

export function transformSegmentData(data) {
  const validSegments = data?.filter(item => item?.segmentGroupId !== null)

  const groupedBySegmentGroupId = validSegments?.reduce((acc, item) => {
    const groupId = item?.segmentGroupId
    if (!acc[groupId]) {
      acc[groupId] = {
        id: groupId,
        name: item?.segmentGroupName,
        segments: [],
      }
    }

    acc[groupId].segments.push({
      id: item?.segmentId,
      name: item?.segmentName,
    })

    return acc
  }, {})

  return Object.values(groupedBySegmentGroupId || {})
}

export const getPublicImageUrl = (imageUrl = '', defaultImage = 'img/no-product-image-found.png') => {
  if (!imageUrl) {
    return defaultImage
  }

  return `${location.protocol}//${import.meta.env.VITE_FE_HOST_URL}/${imageUrl}`
}
